export default {"src":"/_next/static/media/circle-pattern.d98faac8.svg","height":103,"width":103,"blurWidth":0,"blurHeight":0};